/**
 * AFTER AN EXHIBITION — D-EZ-103.
 *
 * An exhibition used to end on the results and one red "New race" button that
 * asked whether to throw the race away. Now the flag falls and the player is
 * offered the next thing to do, not a confirmation.
 */

export interface ExhibitionHandoffProps {
  raceName: string;
  winnerName: string | null;
  onRunAgain: () => void;
  onPickTrack: () => void;
  onStartLeague: () => void;
  /** Shown only when there is an edition to read. */
  onReadPaper?: () => void;
}

export default function ExhibitionHandoff({
  raceName,
  winnerName,
  onRunAgain,
  onPickTrack,
  onStartLeague,
  onReadPaper,
}: ExhibitionHandoffProps) {
  return (
    <div className="rwhandoff exhand" role="group" aria-labelledby="exhand-h">
      <p className="kicker">Exhibition · checkered flag</p>
      <h2 id="exhand-h">{winnerName ? `${winnerName} wins the ${raceName}` : `That's the ${raceName}`}</h2>
      <p className="rwhandoff__line">What next?</p>
      <div className="rwhandoff__row">
        <button type="button" className="btn btn--hot btn--big exhand__btn" onClick={onRunAgain}>
          Run another race here
        </button>
        <button type="button" className="btn exhand__btn" onClick={onPickTrack}>
          Pick a new track
        </button>
        <button type="button" className="btn exhand__btn" onClick={onStartLeague}>
          Start a league
        </button>
        {onReadPaper && (
          <button type="button" className="btn btn--quiet exhand__btn" onClick={onReadPaper}>
            Read the paper
          </button>
        )}
      </div>
    </div>
  );
}
